import { API, Auth } from 'aws-amplify';

export function createCheckoutSession() {
  return async () => {
    const init = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      },
      body: {}
    };
    const { url } = await API.post('BillingCheckoutGateway', '/billing/checkout', init);
    window.location.href = url;
  };
}

export function createPortalSession() {
  return async () => {
    const init = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      },
      body: {}
    };
    const { url } = await API.post('BillingPortalGateway', '/billing/portal', init);
    window.location.href = url;
  };
}
